module.exports = __webpack_public_path__ + "static/Edgio-4fa2bae61272b4264a69443e9136d040.svg";